import api from '../api/api';

// --- Course Enrollments ---

const checkEnrollment = async (courseId) => {
  try {
    const response = await api.get(`/enrollments/check?courseId=${courseId}`);
    return response.data.data; // Should be true or false
  } catch (error) {
    throw error;
  }
};

const getMyEnrollments = async () => {
    try {
        const response = await api.get('/enrollments/my-enrollments');
        return response.data.data; // Returns Array of Course Enrollments
    } catch (error) {
        throw error;
    }
}

// --- Resource Enrollments (NEW) ---

const checkResourceEnrollment = async (resourceId) => {
  try {
    // Assuming your backend endpoint follows this pattern
    const response = await api.get(`/resource-enrollments/check?resourceId=${resourceId}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const getMyResourceEnrollments = async () => {
    try {
        // Assuming your backend endpoint follows this pattern
        const response = await api.get('/resource-enrollments/my-enrollments');
        return response.data.data; // Returns Array of Resource Enrollments
    } catch (error) {
        throw error;
    }
}

const enrollmentService = {
  checkEnrollment,
  getMyEnrollments,
  checkResourceEnrollment,
  getMyResourceEnrollments,
};

export default enrollmentService;